var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, html, LitElement, property } from 'lit-element';
import i18n from 'roddeh-i18n';
import '../components/exponea-popup-block';
import '../components/swogo-popup-block';
import '@tauceti/web-components-loader/dist/loader-ring';
let ProductAddedModal = class ProductAddedModal extends LitElement {
    constructor() {
        super(...arguments);
        this.product = null;
        this.productID = '0';
        this.loading = true;
        this.currency = '';
        this.decimalDigits = 2;
        this.quantity = 1;
        this.capacity = '';
        this.unitPrice = '';
        this.sku = '';
        this.promotionPrice = null;
        this.productAsGift = false;
        this.exponeaEnabled = false;
        this.swogoEnabled = false;
        this.altshopID = '1';
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html ` <div>
            ${this.loading || this.product === null
            ? html `
                      <div class="loading-container">
                          <loader-ring size="20" color="var(--color-primary)"></loader-ring>
                          ${i18n('Loading')}
                      </div>
                  `
            : html `
                      <div class="header">${i18n('Produkt zostal dodany do Twojego koszyka')}</div>
                      <div class="product">
                          <div class="product-image">
                              ${this.product.product_sticker
                ? html `
                                        <div class="product-custom-sticker">
                                            <img src="${this.product.product_sticker}" />
                                        </div>
                                    `
                : html ``}
                              <img src="${this.productImageUrl}" />
                          </div>
                          <div class="product-name">${this.productName}</div>
                          <div class="product-quantity">
                              ${i18n('Quantity')} : <span>${this.quantity}</span>
                              <p>${this.capacity}</p>
                              <p>${this.unitPrice}</p>
                          </div>
                          <div class="product-price">
                              <div class="price-box">
                                  ${this.productPrice != this.product.catalog_price
                ? html `
                                            <span
                                                >${this.productPrice.toFixed(this.decimalDigits)} ${this.currency}</span
                                            >
                                            <del
                                                >${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                ${this.currency}</del
                                            >
                                        `
                : html `
                                            <span
                                                >${this.product.catalog_price.toFixed(this.decimalDigits)}
                                                ${this.currency}</span
                                            >
                                        `}
                              </div>
                          </div>
                          <div class="product-go-to-cart">
                              <a href="/cart" role="button">${i18n('Pokaz koszyk')}</a>
                          </div>
                      </div>

                      ${this.swogoEnabled ? html ` <swogo-popup-block></swogo-popup-block> ` : ``}
                      ${this.exponeaEnabled
                ? html ` <exponea-popup-block altshopID="${this.altshopID}"></exponea-popup-block> `
                : ``}
                  `}
        </div>`;
    }
    connectedCallback() {
        super.connectedCallback();
        if (typeof window.__STATE__ !== 'undefined') {
            this.currency = window.__STATE__.localization.currency;
            this.decimalDigits = window.__STATE__.localization.decimal_digits;
            this.exponeaEnabled = window.__STATE__.functions.exponea_enabled;
            this.swogoEnabled = window.__STATE__.functions.swogo_enabled;
        }
        fetch('/api/catalog/product', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ sku: this.sku, altshop_id: this.altshopID }),
        })
            .then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response;
        })
            .then((response) => response.json())
            .then((productData) => {
            this.loading = false;
            this.product = productData;
        })
            .catch((err) => {
            console.error('Error while fetching product data', err);
        });
    }
    /**
     * Pobierz URL głównego obrazka produktu lub aktualnie wybranego koloru
     */
    get productImageUrl() {
        if (this.product === null) {
            return '';
        }
        let imageUrl = '';
        // Falback/default: obrazek produktu
        if (imageUrl === '') {
            this.product.main_image.sizes.forEach((size) => {
                if (size.size === '500x500') {
                    imageUrl = size.url;
                }
            });
        }
        return imageUrl;
    }
    get productName() {
        if (this.product === null) {
            return '';
        }
        let name = this.product.name;
        if (typeof this.product.variant_sku !== 'undefined' && this.product.attributes) {
            this.product.attributes.forEach((attr) => {
                if (attr.sku === this.sku && attr.attribute_name) {
                    name += ' - ' + attr.attribute_name;
                }
            });
        }
        return name;
    }
    get productPrice() {
        if (this.product === null) {
            return 0;
        }
        let price = this.product.price;
        if (this.productAsGift && this.promotionPrice) {
            price = this.promotionPrice;
        }
        return price;
    }
};
__decorate([
    property({ type: Object })
], ProductAddedModal.prototype, "product", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "productID", void 0);
__decorate([
    property({ type: Boolean })
], ProductAddedModal.prototype, "loading", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "currency", void 0);
__decorate([
    property({ type: Number })
], ProductAddedModal.prototype, "decimalDigits", void 0);
__decorate([
    property({ type: Number })
], ProductAddedModal.prototype, "quantity", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "capacity", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "unitPrice", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "sku", void 0);
__decorate([
    property({ type: Number })
], ProductAddedModal.prototype, "promotionPrice", void 0);
__decorate([
    property({ type: Boolean })
], ProductAddedModal.prototype, "productAsGift", void 0);
__decorate([
    property({ type: Boolean })
], ProductAddedModal.prototype, "exponeaEnabled", void 0);
__decorate([
    property({ type: Boolean })
], ProductAddedModal.prototype, "swogoEnabled", void 0);
__decorate([
    property({ type: String })
], ProductAddedModal.prototype, "altshopID", void 0);
ProductAddedModal = __decorate([
    customElement('product-added-modal')
], ProductAddedModal);
export default ProductAddedModal;
